import { UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';

export class BusinessLocation {
    public id: number = 0;
    public businessId: number = 0;
    public allowPickUpBuyers: boolean = false;
    public allowPickUpCarriers: boolean = false;
    public addressId?: number;

    public get permissionsGroupType(): UserEntityPermissionsType {
        return UserEntityPermissionsType.Businesses;
    }

    public get permissionsIdToCheck(): number {
        return this.businessId;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): BusinessLocation {
        const businessDeliveryDetails: BusinessLocation = new BusinessLocation();

        businessDeliveryDetails.id = this.id;
        businessDeliveryDetails.businessId = this.businessId;
        businessDeliveryDetails.allowPickUpBuyers = this.allowPickUpBuyers;
        businessDeliveryDetails.allowPickUpCarriers = this.allowPickUpCarriers;
        businessDeliveryDetails.addressId = this.addressId;

        return businessDeliveryDetails;
    }
}
